import { createContext, ReactNode, useContext } from "react";
import { PredefinedRangeType } from "./PredefinedDates";

export type Props = {
  value: Date | null
  onChange: (v: Date | null) => void
  selectsRange?: boolean
  monthsShown?: number
  predefinedRanges?: PredefinedRangeType[]
}

const DatePickerContext = createContext<Props>({
  value: null,
  onChange: () => {},
  selectsRange: false,
  predefinedRanges: [],
});

export const useDatePickerContext = () => {
  return useContext(DatePickerContext);
};
export const DatePickerContextProvider = DatePickerContext.Provider;
